import {
  reactive,
  ref,
  Ref,
  computed,
  onMounted,
  onUnmounted,
  getCurrentInstance,
  ComponentInternalInstance,
} from '@vue/composition-api';
import dayjs from 'dayjs';
import i18n, { i18n_t } from '@/locales/i18n';
import smh, { SMH } from '@/renderer/scripts/smh';
import tips from '@/renderer/scripts/utils/tips';
import { dayjsUsage } from '@/renderer/scripts/utils/dayjsUsage';
import store from '@/renderer/store';
interface ListMoreOptions {
  searchId: string;
  spaceOrgId: number;
  marker: number;
  groupBy: 'operationTime';
}
export type OptionType = 'day' | 'week' | 'halfMonth' | 'month' | 'year';
type Handler = {
  methods: {
    getData: (val: OptionType, isInit: Boolean) => Promise<void>;
    pushDynamicList: () => Promise<void>;
  };
  filter: Ref<OptionType>;
  filterOptions: { label: string; value: string }[];
  dynamicList: Ref<SMH.DynamicDataContents[]>;
  loading: Ref<boolean>;
  curHasMore: Ref<boolean>;
  moreLoading: Ref<boolean>;
};
export default function dynamicHandler(spaceId: Ref<string>, selectedItem: any, orgId: number): Handler {
  const vm = (getCurrentInstance() as ComponentInternalInstance).proxy;
  const filter = ref<OptionType>('week');
  const loading = ref<boolean>(true);
  const dynamicList = ref<SMH.DynamicDataContents[]>([]);
  const curSearchId = ref<String>('');
  const curHasMore = ref<boolean>(false);
  const moreLoading = ref<boolean>(false);
  const filterOptions = [
    {
      label: i18n_t('今天'),
      value: 'day',
    },
    {
      label: i18n_t('近七天'),
      value: 'week',
    },
    {
      label: i18n_t('近十五天'),
      value: 'halfMonth',
    },
    {
      label: i18n_t('近一个月'),
      value: 'month',
    },
  ];

  // 当购买了企业版之后才发送请求
  const isPersonal = computed(() => store.getters.editionFlag !== 'personal');
  !isPersonal &&
    reporter.report('pay', {
      pay_source_show: 'details_activities_tips',
    });
  // 定时获取协作动态的数据
  let timer: number | undefined;
  // 记录加载更多的时候需要的数据
  const moreOpt = reactive<ListMoreOptions>({
    searchId: '',
    spaceOrgId: vm.$store.getters.orgId,
    marker: 0,
    groupBy: 'operationTime',
  });
  const methods = {
    // 获取数据
    async getData(val: OptionType, isInit: Boolean) {
      if (!isPersonal.value) {
        loading.value = false;
        return;
      }
      const days = dayjsUsage(val, 'YYYY-MM-DD HH:mm:ss');
      if (isInit) {
        loading.value = true;
      }
      moreOpt.spaceOrgId =
        +vm.$route.query?.spaceOrgId || selectedItem.value?.spaceOrgId || selectedItem.value?.orgId || orgId;
      const params: SMH.GetSpaceDynamicParams = {
        // 此处spaceId 还需考虑从与我相关跳转过来切换从相应的spaceId 否则查到的动态不正确
        spaceId: (vm.$route?.query?.spaceId || spaceId?.value).toString(),
        dirPath: selectedItem.value?.path?.join('/'),
        // actionTypeDetail:optionType,
        startTime: dayjs(days.startTime).format('YYYY-MM-DD HH:mm:ss'),
        endTime: dayjs(days.endTime).format('YYYY-MM-DD HH:mm:ss'),
        groupBy: 'operationTime',
        spaceOrgId: moreOpt.spaceOrgId,
      };
      try {
        const { data } = await smh.userAPI.getDynamics(params);
        // 新增isUserBelongSpace字段判断是否可以跳相应空间
        const DynamicData = data.contents.map(item => {
          item.list.forEach(dynamicItem => (dynamicItem.isUserBelongSpace = selectedItem.value?.isUserBelongSpace));
          return item;
        });
        curSearchId.value = data.searchId;
        curHasMore.value = data.hasMore;
        // marker为0的话再次获取动态就不用传
        if (data.nextMarker) {
          moreOpt.marker = data.nextMarker;
        }
        moreOpt.searchId = data.searchId;
        dynamicList.value.map(item => item);
        dynamicList.value = [...DynamicData];
      } catch (err: MsgError) {
        if (!['SpaceNotFound', 'NoSpace'].includes(err.code)) {
          tips.error(err as MsgError);
        }
        curSearchId.value = '';
        curHasMore.value = false;
        moreOpt.searchId = '';
        dynamicList.value = [];
      } finally {
        loading.value = false;
      }
    },
    async pushDynamicList() {
      moreLoading.value = true;
      if (!isPersonal.value) {
        loading.value = false;
        return;
      }
      try {
        const { data } = await smh.userAPI.getDynamicsMore(moreOpt);
        const DynamicData = data.contents.map(item => {
          item.list.forEach(dynamicItem => (dynamicItem.isUserBelongSpace = selectedItem.value?.isUserBelongSpace));
          return item;
        });
        curSearchId.value = data.searchId;
        curHasMore.value = data.hasMore;
        if (data.nextMarker) {
          moreOpt.marker = data.nextMarker;
        }
        dynamicList.value.push(...DynamicData);
      } catch (err) {
        tips.error(err as MsgError);
      }
      moreLoading.value = false;
    },
  };
  onMounted(() => {
    methods.getData(filter.value, true);
    timer = window.setInterval(() => {
      methods.getData(filter.value, false);
    }, 20000);
  });
  onUnmounted(() => {
    window.clearInterval(timer);
    timer = undefined;
  });
  return {
    methods,
    filterOptions,
    filter,
    loading,
    dynamicList,
    curHasMore,
    moreLoading,
  };
}
